import { PropsWithChildren } from 'react'

export function ArticlesSectionGrid({ children }: PropsWithChildren) {
  return (
    <div className='grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-16 lg:grid-cols-3 xl:grid-cols-4'>
      {children}
    </div>
  )
}
